import { render, staticRenderFns } from "./EmptyContent.vue?vue&type=template&id=242af29a&"
import script from "./EmptyContent.vue?vue&type=script&lang=ts&"
export * from "./EmptyContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports